<ng-container>
	<base-display #display [alignment]="'right'" [smallLetters]="s()" [bigLetters]="b()" [unit]="''" [scaleType]="_saving?'loadinganimation':''"></base-display>
</ng-container>